import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { DEFAULT_STATUS_UUIDS } from "../../../utils/globalConstantUtil";
import { employeeSearch } from "../../../services/bukken/employeeService";

export const defaultEmployeeName = async () => {
  const employees = await employeeSearch();
  const userName = JSON.parse(localStorage.getItem("loginUserInfo"))?.user_name;
  const user_uuid = JSON.parse(localStorage.getItem("loginUserInfo"))?.user_uuid;
  const currentEmployee = employees?.find((item) => item.user_uuid === user_uuid);
  const employeeName = currentEmployee?.name ?? userName ?? "";
  return employeeName;
};

export const initialSearchAdvancedQuotation = {
  quotation_info: "",
  bukken_info: "",
  quotation_state: [],
  // quotation_state: DEFAULT_STATUS_UUIDS.quotation,
  submit_name: "",
  quotation_create_from_date: "",
  quotation_create_to_date: "",
  quotation_expiration_from_date: "",
  // , quotation_expiration_from_date: dayjs().startOf('day').format("YYYYMMDDHHmmss")
  quotation_expiration_to_date: "",
  quotation_create_limit_from_date: "",
  quotation_create_limit_to_date: "",
  total_amount_from: "",
  total_amount_to: "",
  manager_name: "",
  manager_uuid: "",
  // manager_name: JSON.parse(localStorage.getItem("loginUserInfo"))?.user_name,
  representative_flg: false,
  quotation_number: "",
  quotation_name: ""
};

export const initialSearchAdvancedInvoice = {
  invoice_info: "",
  bukken_info: "",
  invoice_status: [],
  // invoice_status: DEFAULT_STATUS_UUIDS.invoice,
  billing_company_name: "",
  billing_dt_from_date: "",
  billing_dt_to_date: "",
  limit_dt_from_date: "",
  // limit_dt_from_date: dayjs().startOf("day").format("YYYYMMDDHHmmss"),
  limit_dt_to_date: "",
  payment_dt_from_date: "",
  payment_dt_to_date: "",
  total_amount_from: "",
  total_amount_to: "",
  manager_name: "",
  manager_uuid: "",
  // manager_name: JSON.parse(localStorage.getItem("loginUserInfo"))?.user_name,
  invoice_number: "",
  invoice_name: ""
};

// const defaultSearchSync = async () => ({
//   own_manager_name: await defaultEmployeeName(),
//   from_dt: dayjs().startOf("day").format("YYYYMMDDHHmmss"),
//   to_dt: ""
// });
// const defaultSearch = await defaultSearchSync();

const defaultSearch = {
  own_manager_name: "",
  own_manager_uuid: null,
  own_manager_init_user_uuid: "",
  from_dt: dayjs().startOf("day").format("YYYYMMDDHHmmss"),
  to_dt: ""
};
const initialSearchBasic = {
  free_keyword: null,
  ...defaultSearch
};

export const stateQuotationInvoiceSlice = createSlice({
  name: "stateQuotationInvoice",
  initialState: {
    pageActiveQuotation: 1,
    pageActiveInvoice: 1,
    bodySearchQuotation: {
      ...defaultSearch
    },
    bodySearchInvoice: {
      ...defaultSearch
    },
    searchBasic: {
      ...initialSearchBasic
    },
    searchAdvancedInvoice: {
      ...initialSearchAdvancedInvoice
    },
    searchAdvancedQuotation: {
      ...initialSearchAdvancedQuotation
    },
    isSearchAdvanced: false
  },
  reducers: {
    setPageActiveQuotation: (state, action) => {
      state.pageActiveQuotation = action.payload;
    },
    setPageActiveInvoice: (state, action) => {
      state.pageActiveInvoice = action.payload;
    },
    setConditionQuotation: (state, action) => {
      state.bodySearchQuotation = action.payload;
    },
    setConditionInvoice: (state, action) => {
      state.bodySearchInvoice = action.payload;
    },

    setSearchBasic: (state, action) => {
      state.searchBasic = action.payload;
      // Commented out: the following lines were previously syncing Basic search values into the
      // Advanced search state whenever the user changed anything in the Basic panel.
      // This caused the Basic and Advanced search sections to be tightly coupled:
      //   - Selecting a date range in Basic would automatically fill the Advanced date fields.
      //   - Setting a manager name in Basic would overwrite the Advanced manager name field.
      // Basic and Advanced search are now treated as fully independent — changes in one panel
      // should not affect the other.
      // state.searchAdvancedQuotation.quotation_expiration_from_date = action.payload.from_dt || "";
      // state.searchAdvancedQuotation.quotation_expiration_to_date = action.payload.to_dt || "";

      // state.searchAdvancedInvoice.limit_dt_from_date = action.payload.from_dt || "";
      // state.searchAdvancedInvoice.limit_dt_to_date = action.payload.to_dt || "";

      // state.searchAdvancedQuotation.manager_name = action.payload.own_manager_name;
      // state.searchAdvancedInvoice.manager_name = action.payload.own_manager_name;
    },
    setManagerNameBasic: (state, action) => {
      state.searchBasic.own_manager_name = action.payload;
    },
    setFromDtBasic: (state, action) => {
      state.searchBasic.from_dt = action.payload ? dayjs(action.payload).format("YYYYMMDDHHmmss") : null;
    },

    setToDtBasic: (state, action) => {
      state.searchBasic.to_dt = action.payload ? dayjs(action.payload).format("YYYYMMDDHHmmss") : null;
    },

    setAdvancedInvoice: (state, action) => {
      state.searchAdvancedInvoice = action.payload;
    },
    setAdvancedQuotation: (state, action) => {
      state.searchAdvancedQuotation = action.payload;
    },
    setIsSearchAdvanced: (state, action) => {
      state.isSearchAdvanced = action.payload;
    },
    setResetConditionSearch: (state) => {
      state.bodySearchInvoice = {
        ...defaultSearch
      };
      state.bodySearchQuotation = {
        ...defaultSearch
      };
      state.searchAdvancedInvoice = { ...initialSearchAdvancedInvoice };
      state.searchAdvancedQuotation = { ...initialSearchAdvancedQuotation };
      state.searchBasic = { ...initialSearchBasic };
      state.isSearchAdvanced = false;
    }
  }
});

export const {
  setPageActiveQuotation,
  setPageActiveInvoice,
  setConditionQuotation,
  setConditionInvoice,
  setSearchBasic,
  setAdvancedInvoice,
  setAdvancedQuotation,
  setIsSearchAdvanced,
  setResetConditionSearch,
  setManagerNameBasic,
  setFromDtBasic,
  setToDtBasic
} = stateQuotationInvoiceSlice.actions;

export default stateQuotationInvoiceSlice.reducer;
